import React, { useCallback, useState } from 'react';
import PropTypes from 'prop-types';
import { InfoMessage, PopOutChart } from 'sharedComponents';
import { CHART_PLUGINS } from 'sharedComponents/Chart/constants';
import useChartConfig from './useChartConfig';
import '../CoolingAnomalyChart/style.scss';
import './style.scss';

const chartPlugins = [
    CHART_PLUGINS.NO_DATA_TO_DISPLAY,
    CHART_PLUGINS.HIGHCHARTS_MORE,
    CHART_PLUGINS.EXPORTING,
    CHART_PLUGINS.OFFLINE_EXPORTING,
    CHART_PLUGINS.STOCK,
];

const isLiveChartInstance = (chart) =>
    !!chart?.series && !!chart?.options?.chart && !chart?.options?.chart?.forExport;

const ACS1000CoolingAnomalyChart = ({
    coolingAnomalyKPI,
    loadingStatus,
    assetDetails,
    isZoomed,
    actions,
    chartRef,
    chartHeight,
    mainChartHeader,
    containerRef
}) => {
    const [chartInstance, setChartInstance] = useState(null);

    const handleChartReady = useCallback((chart) => {
        if (!isLiveChartInstance(chart)) { return; }
        setChartInstance(chart);
    }, []);

    const graphOptions = useChartConfig(
        coolingAnomalyKPI,
        coolingAnomalyKPI?.name,
        assetDetails,
        { containerRef, chartInstance, chartHeight }
    );

    return (
        <PopOutChart
            hasKpi={!!coolingAnomalyKPI?.key}
            renderNoKpi={() => <InfoMessage
                title='ABB.Powertrain.Frontend.chartNoKPIsSelected'
                text='ABB.Powertrain.Frontend.chartNoKPIsSelectedUserGuide' />}
            hasData={!!coolingAnomalyKPI?.conditionTrends?.length}
            renderNoData={() => <InfoMessage
                title='ABB.Powertrain.Frontend.chartNoMeasurementData'
                text='ABB.Powertrain.Frontend.chartNoMeasurementDataUserGuide' />}
            enableUniqueScaling={false}
            isZoomed={isZoomed}
            resetServerZoom={() => actions?.reloadConditionInsights?.(assetDetails?.id)}
            setIsZoomed={actions?.setIsZoomed}
            loadingStatus={loadingStatus}
            options={graphOptions}
            modules={chartPlugins}
            container={'acs1000-cooling-anomaly-detection-chart'}
            popOutClassName='drive-anomaly-detection-popout'
            mainChartHeader={mainChartHeader}
            popOutChartHeader={mainChartHeader}
            chartRef={chartRef}
            onChartReady={handleChartReady}
            chartInstance={chartInstance}
            mainChartBanner={null}
        />
    );
};

ACS1000CoolingAnomalyChart.propTypes = {
    coolingAnomalyKPI: PropTypes.object,
    loadingStatus: PropTypes.string,
    assetDetails: PropTypes.object,
    isZoomed: PropTypes.bool,
    actions: PropTypes.shape({
        removeSelectedKpiLegend: PropTypes.func,
        setIsZoomed: PropTypes.func,
        reloadConditionInsights: PropTypes.func
    }),
    chartRef: PropTypes.oneOfType([
        PropTypes.func,
        PropTypes.shape({ current: PropTypes.any })
    ]),
    chartHeight: PropTypes.number,
    mainChartHeader: PropTypes.elementType,
    containerRef: PropTypes.oneOfType([
        PropTypes.func,
        PropTypes.shape({ current: PropTypes.any })
    ])
};

export default ACS1000CoolingAnomalyChart;
